// @flow

import { CookieStorage, isSupported, storage } from 'local-storage-fallback'

const COOKIES_EXPIRE_DAYS = 30

const SUBDOMAINS_TO_REMOVE = ['www', 'shop', 'chat', 'secure']

// this does only work for defined subdomains since a generic implementation would take up 40 kB
// https://stackoverflow.com/questions/9752963/get-domain-name-without-subdomains-using-javascript
// only exported for spec
export function removeSubdomain (hostname: string): string {
  if (!hostname) return hostname

  for (const subdomain of SUBDOMAINS_TO_REMOVE) {
    hostname = hostname.replace(new RegExp(`^${subdomain}\\.`, 'gi'), '')
  }
  return hostname
}

// only exported for spec
export function cookieOptions (): Object {
  if (window.location.protocol.indexOf('https:') === 0) {
    return {
      secure: true,
      SameSite: 'none',
      maxAge: COOKIES_EXPIRE_DAYS * 24 * 60 * 60,
      domain: removeSubdomain(window.location.hostname)
    }
  } else {
    return {
      SameSite: 'none',
      maxAge: COOKIES_EXPIRE_DAYS * 24 * 60 * 60,
      domain: removeSubdomain(window.location.hostname)
    }
  }
}

export function getStorage (storageOptions: Object = {}): Object {
  if (isSupported('cookieStorage')) {
    const options = { ...cookieOptions(), ...storageOptions }
    return new CookieStorage(Object.assign({ prefix: '' }, options))
  } else {
    return storage
  }
}

export function setItem (key: string, value: any, storageOptions: Object = {}): any {
  return getStorage(storageOptions).setItem(key, value)
}

export function getItem (key: string): any {
  return getStorage().getItem(key)
}

export function removeItem (key: string): any {
  return getStorage().removeItem(key)
}
